import {
  SlDivider
} from "./chunk.P6KA27FE.js";

// src/components/divider/divider.ts
var divider_default = SlDivider;
SlDivider.define("sl-divider");

export {
  divider_default
};
